import { render, staticRenderFns } from "./VerticalNavMenuClose.vue?vue&type=template&id=cfa2bb8e&scoped=true&"
import script from "./VerticalNavMenuClose.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuClose.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuClose.vue?vue&type=style&index=0&id=cfa2bb8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa2bb8e",
  null
  
)

export default component.exports